import {ChangeDetectionStrategy, Component} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";

@Component({
    selector: "section-warehouse-order-replenishment-list",
    template: `
        <section-warehouse-order-list [state]="state" [type]="'replenishment'"></section-warehouse-order-list>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarehouseOrderReplenishmentListComponent implements Base.IComponent {


    public readonly state: Base.IState;

    public constructor() {
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "warehouse-orders-replenishment",
            actions: {
                "browse": ["browse_warehouse_orders"]
            }
        };
    }

}
